import React from 'react'
import { ListFilterScreen } from '@containers'
import { NavigationContainer } from '@src/screens/Common/containers'

export const EventsEditContainer = () => (
  <NavigationContainer title="Settings">
    <ListFilterScreen model="events" />
  </NavigationContainer>
)
